/**
 * The team roster, matching api/app/routers/teams.py.
 *
 * Every signed-in user gets every team here: callsign, colour, counts and port
 * blocks. Which teams the caller is IN comes from /auth/me, never from this
 * list, and that separation is what keeps an open roster from granting
 * anything.
 */

import { api, type ApiResult } from '@/api/client';
import type { Team } from '@/types/domain';

export async function listTeams(): Promise<ApiResult<Team[]>> {
  const result = await api.get<{ teams: Team[] }>('/teams', { logged: false });
  return result.ok ? { ...result, data: result.data.teams ?? [] } : result;
}

/** One line per block the team owns, e.g. "UDP 14600-14609"; empty when it owns none. */
export function describePorts(team: Pick<Team, 'tcpPorts' | 'udpPorts'>): string[] {
  const out: string[] = [];
  if (team.tcpPorts) out.push(`TCP ${team.tcpPorts.start}-${team.tcpPorts.end}`);
  if (team.udpPorts) out.push(`UDP ${team.udpPorts.start}-${team.udpPorts.end}`);
  return out;
}
